import { useEffect, useState } from 'react';
import { CopyIcon } from '@icons';

import Tooltip from '@components/tooltip/Tooltip';

interface CopyTextProps {
  textToCopy: string;
  textId?: string;
  className?: string;
  iconColor?: string;
  isDisabled?: boolean;
  onCopy?: () => void;
  text?: string;
  textStyle?: string;
}

const CopyToClipboard = (props: CopyTextProps) => {
  const {
    textToCopy,
    textId = '',
    className = '',
    iconColor = 'text-borderGrey2',
    isDisabled,
    onCopy,
    text = '',
    textStyle
  } = props;

  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const handleClick = (e: React.MouseEvent) => {
    setShowTooltip(true);
    navigator.clipboard.writeText(textToCopy);
    if (onCopy) onCopy();
    e.stopPropagation();
  };

  // how to clean up the timer
  useEffect(() => {
    const timer = setTimeout(() => {
      if (showTooltip) setShowTooltip(false);
    }, 500);

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [showTooltip]);

  return (
    <div
      role="presentation"
      className={`group/tooltip relative flex ${
        isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
      } ${className}`}
      onClick={handleClick}
      data-tooltip-id={`copy-tooltip-${textId || textToCopy}`}
    >
      <CopyIcon
        className={`${iconColor} ${isDisabled ? '' : 'hover:text-grey'}`}
      />
      {text.trim().length > 0 && (
        <div className={`ml-3 text-base font-medium text-primary ${textStyle}`}>
          {text}
        </div>
      )}
      {!isDisabled && (
        <Tooltip
          id={`copy-tooltip-${textId || textToCopy}`}
          type="text"
          showTooltip={showTooltip}
          tooltipText="Copied!"
        />
      )}
    </div>
  );
};

export default CopyToClipboard;
